import useUserStore from 'store/user.store';
import { useTeamQuery } from '@common/cache';

export const useTeamAvailability = () => {
  const { user } = useUserStore();
  const team_id = user?.team?.id;

  const team = useTeamQuery({
    teamId: team_id,
    enabled: !!team_id,
    refetchInterval: 1000 * 120,
  });

  return {
    team: team.data,
  };
};
